import { ProductlineOrderApimodel } from '@models/api-models/product-line';
import { Type } from "class-transformer";
import { AssortmentLineModel } from "../assortment-line-model";
import { OrderLineStateV2 } from "../v2/order-line-state-v2";
import { TempleInclinationEnum } from "../variant-temple-inclination";

export class OrderItemStateV2 {
    public Id: number;
    public Uuid: string;
    public OrderId: number;
    @Type(() => Date)
    public CreatedAt: Date;
    public CustomerNo: string;
    public UserName: string;

    public Reference: string;
    public Engraving: string;
    public Amount: number;
    public Comment: string;

    public ProductLineUuid: string;
    public ProductLineCode: string;
    public ModelCode: string;
    public ModelGroupCode: string;
    public ModelSizeCode: string;
    public ModelConfigurationCode: string;
    public ModelGroupDescription: string;
    public ModelConfigurationDescription: string;

    public ModelUuid: string;
    public ModelGroupUuid: string;
    public ModelSizeUuid: string;
    public ConfigurationUuid: string;
    public ModelConfigurationUuid: string;

    // Add missing numeric ID properties needed for Original* object mapping
    public ModelId: number;
    public ModelGroupId: number;
    public ModelSizeId: number;
    public ConfigurationId: number;
    public ModelConfigurationId: number;

    public Demo: boolean;
    public New: boolean;
    public IsRimless: boolean;
    public IsAsia: boolean;
    public IsFullFrame: boolean;
    public HasFixtures: boolean;
    public HasForms: boolean;
    public IsPrecious: boolean;
    public IsLimited: boolean;
    public FirstTimeDelivery: boolean;

    public IsAnythingDiscontinued: boolean;

    public DiscountCode: string;
    public DiscountPercent: number;
    
    public Age: string;
    public FirstPair: string;
    public Gender: string;
    public TempleInclination: TempleInclinationEnum;
    public LowTempleInclinationPossible: number;
    
    public CaseItemNo: string;
    public CaseItemVariantCode: string;
    public Parts: string;

    @Type(() => OrderLineStateV2)
    public OrderLines: Array<OrderLineStateV2>;

    public SerialNumber: string;

    public PriceJson: string;
    
    // AssortmentLines for Original* models to support first time delivery calculations
    public OriginalModelAssortmentLines: Array<AssortmentLineModel>;
    public OriginalModelGroupAssortmentLines: Array<AssortmentLineModel>;
    public OriginalModelSizeAssortmentLines: Array<AssortmentLineModel>;
    public OriginalConfigurationAssortmentLines: Array<AssortmentLineModel>;
    public OriginalProductLine: ProductlineOrderApimodel;

    public get isFirstTimeDelivery(): boolean {
        return this.FirstTimeDelivery;
    }

    public get isAnythingDiscontinued(): boolean {
        return this.IsAnythingDiscontinued;
    }
    
    public get isNew(): boolean {
        return this.New;
    }
} 